import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f96189a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("变更")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交审批")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("同意")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("撤销")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("作废")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("恢复")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("彻底删除")
const _hoisted_11 = { class: "flow-model-title" }
const _hoisted_12 = { class: "flow-model-subtitle" }
const _hoisted_13 = {
  key: 0,
  class: "flow-model__subtitle mt14"
}
const _hoisted_14 = {
  key: 1,
  class: "flow-model__subtitle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_space, null, {
      default: _withCtx(() => [
        (_ctx.showEdit)
          ? _withDirectives((_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goto(_ctx.editUrl + '/edit/' + _ctx.id)))
            }, [
              _createVNode(_component_a_button, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ])), [
              [_directive_perm, _ctx.editPerm]
            ])
          : _createCommentVNode("", true),
        (_ctx.showChange)
          ? _withDirectives((_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goto(`${_ctx.editUrl}/edit/${_ctx.id}?isChange=true`)))
            }, [
              _createVNode(_component_a_button, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ])), [
              [_directive_perm, _ctx.editPerm]
            ])
          : _createCommentVNode("", true),
        (_ctx.permissionsFn('submit'))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.permissionsFn('agree'))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 3,
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.agree()))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.permissionsFn('agree'))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 4,
              type: "primary",
              danger: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reject()))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.permissionsFn('cancel'))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 5,
              onClick: _ctx.cancel
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.permissionsFn('void'))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 6,
              type: "primary",
              danger: "",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.voidAction()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.permissionsFn('delete'))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 7,
              type: "primary",
              danger: "",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteAction()))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.permissionsFn('recycle'))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 8,
              type: "primary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.recycleAction()))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.permissionsFn('completelyDelete'))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 9,
              type: "primary",
              danger: "",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteCompleteRow()))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      confirmLoading: _ctx.loading,
      centered: true,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visible) = $event)),
      onOk: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleOk(_ctx.currentAction))),
      class: "flow-model",
      bodyStyle: {minHeight: '100px'}
    }, {
      title: _withCtx(() => [
        _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.modelMap.get(_ctx.currentAction)?.title), 1),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.modelMap.get(_ctx.currentAction)?.subtitle), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.currentAction == 'delete')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 当前审批状态：" + _toDisplayString(_ctx.record?.flowStatusName), 1))
          : _createCommentVNode("", true),
        (_ctx.currentAction == 'delete')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, "删除原因"))
          : _createCommentVNode("", true),
        _createVNode(_component_a_textarea, {
          "show-count": "",
          value: _ctx.approvalContent,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.approvalContent) = $event)),
          placeholder: '请输入' + _ctx.modelMap.get(_ctx.currentAction)?.title + '，最多200字',
          "auto-size": { minRows: 3 },
          maxlength: 200,
          allowClear: ""
        }, null, 8, ["value", "placeholder"])
      ]),
      _: 1
    }, 8, ["confirmLoading", "visible"])
  ], 64))
}